// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2SJWY","icon":"SortAdornment_icon__I2q-k","up":"SortAdornment_up__g8_sO","down":"SortAdornment_down__1UeZm","active":"SortAdornment_active__1XqXz"};